export const LAN = {
    ENGLISH: 'en',
    ARABIC: 'ar',
    KURDISH: 'kr'
};
